import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Path } from 'leaflet';
import { Location } from '@angular/common';
import { DialogModule} from 'primeng/dialog';
import { MapService } from './map.service';
import { DataLayerService } from './data-layer.service';
import { ConfigService } from './config.service';

// declare all javascript variables/functions defined elsewhere 
declare var mousePosition: any;
declare var globalMapComponent: any;
declare var $;
declare var L;

@Component({
	selector: 'map-component',
	standalone: false,
	templateUrl: 'map.component.html',
	styleUrls: ['map.component.css']

})
export class MapComponent implements OnInit, OnDestroy {

	mapService: MapService;
	private configService: ConfigService;
	private _dataLayerService: DataLayerService;
	radarLegendUrl;
	hideRadarLegend = true;
	linkLabel = "Click here for more information.";

	stationDetails;		// holds the tooltip content when a station is selected for display in the PrimeNG dialog
	showStationDetails = false;
	currentStationId; 	// when stations details are displayed, this saves the numId of that station
	
	// preferencesObservable;

	constructor(
		mapService: MapService, 
		configService: ConfigService,
		private dataLayerService: DataLayerService, 
		private router: Router, 
		private location: Location ) {

		this.mapService = mapService;
		this.configService = configService;
		this._dataLayerService = dataLayerService;
		this.router = router;
	}

	ngOnInit() {
		// console.log(this.mapService.activeTileLayer);
		const currentCenter = this.mapService.getCurrentCenter();
		const currentZoom = this.mapService.getCurrentZoom();
		console.log(currentCenter);

		const map = new L.Map('map', {
		zoomControl: false,
		center: currentCenter,
		zoom: currentZoom,
		// zoomDelta: .5,  need to figure out how to use these - can they be used with tiles (not vector)
		// wheelPxPerZoomLevel: 60,
		zoomSnap: .25, // controls how quickly zoom levels change
		minZoom: 4,
		maxZoom: 18,
		layers: [this.mapService.activeTileLayer]
		});

		/* this code demonstrates how to display polygons on the map
		L.geoJson(novastarSystemPolygonsJurisdictions, {
			// For now hard-code but could determine color from a property
			onEachFeature: onEachPolygonFeature,
			style: function (feature) {
				return { color: "yellow", weight: 1, opacity: 1, fillOpacity: .3 };
			}
		}).addTo(map);
		*/

		// Add zoom buttons at the top of the map
		// L.control.zoom({ position: 'topright' }).addTo(map);
		let zoomHome = L.Control.zoomHome({ position: 'topright', zoomHomeTitle: 'Zoom to original extent' }).addTo(map);

		const up = this.configService.getUserPreferences();
		zoomHome.setHomeCoordinates({lat: up.preferences.map.latitude, lng: up.preferences.map.longitude});
		zoomHome.setHomeZoom(up.preferences.map.zoom);

		// console.log(zoomHome.getHomeCoordinates());
		// console.log(zoomHome.getHomeZoom());

		// Add a layer selector.  Gets list from the mapService.
		L.control.layers(this.mapService.baseMaps).addTo(map);

		// Show scale for perspective at bottom of map
		L.control.scale().addTo(map);

		// Show the mouse control
		mousePosition().addTo(map);

		//
		// Every time the map layer, zoom, or center of the map changes, that selection should be saved so when the user goes to another
		// view (station table or imact table for example), and then back to the map, the same map layer will
		// be visible.
		//
		// Additionally, these changes must be saved to the user preference settings.
		// WAIT!  Do we actually want to save any movement back to user preferences?
		//
		map.on('baselayerchange', function(e: any) {
			// console.log(e);
			let name = e.name.split(' ').join('');
			$('#' + name + 'Radio').prop('checked', true);
			this.mapService.setActiveTileLayer(this.mapService.baseMaps[e.name]);
			// this.configService.setUserPreference('userPreferences.map.baseMap', e.name );
		}, this);

		map.on('moveend', function(e: any) {
			this.mapService.setCurrentCenter(map.getCenter());

			// zoom
			this.mapService.setCurrentZoom(map.getZoom());
			// this.configService.setUserPreference('userPreferences.map.zoom', map.getZoom());
		}, this);

		this.mapService.map = map;


		// make map height the remainder of the screen (entire screen height minus the top menu bar height)
		this.calculateAndSetMapHeight();
		map._onResize();
		this.attachEvents();

		//
		// part of the map refresh once router was added
		//
		this.mapService.map.eachLayer(function(layer: Path) {
			// console.log(layer);
			layer.bringToFront();

			// When moving from Leaflet0.7.7, the background layer wouldn't draw when changing from another route back to map.
			// Removing the layer and adding it back seems to be a working solution.
			// remove the current map layer
			this.mapService.map.removeLayer(this.mapService.activeTileLayer);

			// re-add the layer
			layer.addTo(this.mapService.map);
		}, this);

		if ( this.mapService.getShowLegend()) {
			this.mapService.toggleLegendMain();
		}

		// remind our map which layers have been activated
		this.mapService.refreshAllLayers();
		this._dataLayerService.refreshLegendList();
		globalMapComponent = this;

		const dataLayer = this.dataLayerService.getDataLayerDetails('radar');
		this.radarLegendUrl = dataLayer.special2;

		// finally - set map according to preferences
		/*
		this.mapService.reactToPreferenceChange(
			this.configService.getConfigFilePreferences());
			*/
		// Watch for changes to the user preferences
		// and redraw map accordingly.
		/*
		this.preferencesObservable = this.configService.getPreferencesObservable().subscribe ({
			next: (p) => {
				console.log("Reacting to preference change.");
				// console.log(p.preferences.map.baseMap);
				this.mapService.reactToPreferenceChange(p);
			}
			}
		);
		*/
	}

	attachEvents() {
		window.onresize = () => {
			this.calculateAndSetMapHeight();
		};
	}

	calculateAndSetMapHeight () {
		const theMap = document.getElementById('map');
		const theTopMenu = document.getElementById('topMenu');
		if ( theMap != null && theTopMenu != null ) {
			const height = (document.documentElement.clientHeight - theTopMenu.offsetHeight) + 'px';
			theMap.style.height = height;
		}
	}

	ngOnDestroy() {
		// want to avoid memory leak by leaflet.  This removes the layers from the map but doesn't effect the active flag.
		this.mapService.removeAllLayers();
		// this.preferencesObservable.unsubscribe();
	}

	getDataLayers() {
		this._dataLayerService.getDataLayers().then(dataLayers => { console.log(dataLayers); });
	}

	gotoDetail(stationID: string) {
			console.log (stationID);
			const link = ['/stationDashboard', stationID ];
			const tree = this.router.parseUrl(this.location.path());
			this.router.navigate(link, { queryParams: tree.queryParams});
	}

	gotoDetailForCurrentStationId() {
		this.gotoDetail(this.currentStationId);
	}

	// gets the tooltip content for the selected station
	showDetail(stationID: string) {
			// console.log (stationID);
			this.currentStationId = stationID;
			const stationIDnum = +stationID;
			this._dataLayerService.getActiveLayers().then (dataLayers => {
				const dataLayer = dataLayers.filter(dl => 
					dl.dataType == 'precipStations' || dl.dataType == 'waterLevelStations' || dl.dataType == 'streamFlowStations')
				if ( dataLayer.length == 1 ) {
					const item = dataLayer[0].value.features.filter( station => station.properties.stationSummary.numId === stationIDnum );
					this.stationDetails = item[0].properties.stationSummary.tooltipContent;
					this.showStationDetails = true;
				}
			});
	}

	gotoFloodImpactDetail(stationID: string) {
			console.log (stationID);
			const link = ['/impactTable', stationID ];
			const tree = this.router.parseUrl(this.location.path());
			this.router.navigate(link, { queryParams: tree.queryParams});
	}

}
